import z from 'zod'
import { CanvasDataV1 } from './v1'

export const CURRENT_VERSION = 1

export const CanvasData = CanvasDataV1
export type CanvasData = z.infer<typeof CanvasData>

export * from './manager'
export * from './v1'
